import KioskLogo from "./KioskLogo";
import { useSetLayout } from "@/shared/atoms/useLayout";
import useKioskSettingsQuery from "@/shared/queries/kioskSettings/useKioskSettingsQuery";
import useOpeningTimesStatusQuery, {
  OPENING_TIMES_OPEN_STATUS,
} from "@/shared/queries/openingTimes/useOpeningTimesStatusQuery";
import { kioskDeliveryMethods } from "@/shared/utils/constant";
import { useEffect, useMemo } from "react";
import Kiosk from "./Kiosk";
import KioskDeliveryMethod from "./KioskDeliveryMethod";
import useKioskTranslation from "./useKioskTranslation";

const KioskDeliveryMethods = () => {
  const { t } = useKioskTranslation();
  const setHideFullscreen = useSetLayout();
  const kioskSettingsQuery = useKioskSettingsQuery();
  const openingTimesStatusQuery = useOpeningTimesStatusQuery();

  const visibleMethods = useMemo(() => {
    const configuredMethods = kioskSettingsQuery.data?.delivery_methods || [];
    const configured = configuredMethods.length
      ? kioskDeliveryMethods.filter((method) =>
          configuredMethods.includes(method.value)
        )
      : kioskDeliveryMethods;
    const methods = configured.length ? configured : kioskDeliveryMethods;

    const statuses = openingTimesStatusQuery.data;
    if (!statuses) return methods;

    return methods.filter(
      (method) => statuses[method.value]?.status === OPENING_TIMES_OPEN_STATUS
    );
  }, [
    kioskSettingsQuery.data?.delivery_methods,
    openingTimesStatusQuery.data,
  ]);

  useEffect(() => {
    setHideFullscreen((current) => ({ ...current, showFullscreen: false }));
  }, []);

  return (
    <Kiosk>
      <div className="flex h-screen flex-col items-center justify-center p-20">
        <div className="flex justify-center">
          <KioskLogo className="w-full h-auto max-w-160" />
        </div>
        <div className="mb-12 font-bold text-[5vw] text-center">
          {t("whereToEat")}
        </div>
        <div className="flex justify-center gap-24">
          {visibleMethods.map((method) => (
            <KioskDeliveryMethod key={method.id} {...method} />
          ))}
        </div>
      </div>
    </Kiosk>
  );
};

export default KioskDeliveryMethods;
